import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const CURRENCY_SYMBOLS = { TRY: '₺', EUR: '€', USD: '$' };

export const currencySymbol = (code) => CURRENCY_SYMBOLS[code] || '₺';

export const getTourCurrency = (tour) => tour?.currency || (tour?.tour_type === 'yurtdisi' ? 'EUR' : 'TRY');

export const tourCurrencySymbol = (tour) => currencySymbol(getTourCurrency(tour));

const DATE_LOCALES = { tr: 'tr-TR', en: 'en-GB', de: 'de-DE', es: 'es-ES', zh: 'zh-CN', ar: 'ar' };

export const localeFor = (lang) => DATE_LOCALES[lang] || 'tr-TR';

export const parseISODate = (value) => {
  const [y, m, d] = value.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const toISODate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const formatTourDate = (value, lang, options = { day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' }) =>
  parseISODate(value).toLocaleDateString(localeFor(lang), options);
